import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import index from "../../../api/auth/reservations/reservationQuestions";
import ReservationAnswer from "./ReservationAnswer";

export default function ReservationQuestionAnswers({ reservation }) {
  const [reservationQuestions, setReservationQuestions] = useState([]);

  useEffect(() => {
    index(reservation.id, (response) => {
      setReservationQuestions(response);
    });
  }, [reservation.reservation_items?.length]);

  return (
    <Stack>
      <Stack>
        {reservationQuestions?.map((question) => (
          <Stack key={`${reservation.id}-${question.id}`}>
            <Stack>
              <Typography variant="body1">{question.question}</Typography>
            </Stack>
            <Stack>
              <ReservationAnswer reservation={reservation} question={question} />
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}